export const getIndustryColor = (text) => {
  if (!text) return { bg: 'rgba(255,255,255,0.06)', fg: 'rgba(255,255,255,0.35)', border: 'rgba(255,255,255,0.1)' };
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = text.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;
  return {
    bg: `hsla(${hue}, 60%, 15%, 0.45)`,
    fg: `hsl(${hue}, 75%, 75%)`,
    border: `hsla(${hue}, 50%, 35%, 0.5)`
  };
};
